import "virtual:mf-REMOTE_ENTRY_ID:__mfe_internal__shipbob_customers_ui__remoteEntry_js";
// Standalone entry (dev/direct load); importing bootloader triggers its self-mount. Hosts use ./AppMount.
import '@shipbob/waypoint/styles.css';
import { prepareRuntime } from './appMount';

async function boot() {
  await prepareRuntime('boot');
  await import('./bootloader');
}

boot().catch((error) => console.error('[customers-ui] boot failed', error));
